import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Button, Icon, Input, Label } from 'semantic-ui-react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { getCalendlyOnboardingLink, getStripeApiKey } from './PublishModal.utils';
import Calendly from '../../../../modules/calendars/components/Calendly';
import { POPUP_CALENDAR } from '../../../../modules/calendars/constants';
import Modal from '../../../../modules/foundation/components/Modal';
import { GoogleAnalytics } from '../../../../services/analytics';
import { BusinessPropType } from '../../../../services/proptypes';
import { cleanDomainName } from '../../../../utils/urls';
import { SubscriptionsContextConsumer } from '../../PublishBanner.context';
import CheckoutForm from '../CheckoutForm';
import Completion from '../Completion';
import DomainSearchForm from '../DomainSearchForm';
import PaymentOptions from '../PaymentOptions';
import PeriodSelect from '../PeriodSelect';
var PublishModal = /*#__PURE__*/function (_React$Component) {
  _inherits(PublishModal, _React$Component);
  var _super = _createSuper(PublishModal);
  function PublishModal(props) {
    var _this;
    _classCallCheck(this, PublishModal);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handlePaymentOptionsBackButton", function () {
      var _this$state = _this.state,
        hasCustomDomain = _this$state.hasCustomDomain,
        chosenDomain = _this$state.chosenDomain;
      var domains = _this.props.domains;
      var hasDomain = domains && domains.length;
      var needsSelection = chosenDomain == null && !hasCustomDomain;
      if (!hasDomain && !needsSelection) {
        _this.onCustomDomainSelected(null);
      }
    });
    _this.state = {
      chosenDomain: {},
      enteredDomain: '',
      customDomain: '',
      customDomainInputError: false,
      hasCustomDomain: false,
      isAnnual: null,
      email: ''
    };
    _this.handleDomainChange = _this.handleDomainChange.bind(_assertThisInitialized(_this));
    _this.onDomainSelected = _this.onDomainSelected.bind(_assertThisInitialized(_this));
    _this.onHasCustomDomainChanged = _this.onHasCustomDomainChanged.bind(_assertThisInitialized(_this));
    _this.onCustomDomainSelected = _this.onCustomDomainSelected.bind(_assertThisInitialized(_this));
    _this.onPeriodSelected = _this.onPeriodSelected.bind(_assertThisInitialized(_this));
    _this.handleEmailChange = _this.handleEmailChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(PublishModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var domains = this.props.domains;
      if (domains && domains.length) {
        var chosenDomain = {
          DomainName: domains[0].url,
          DomainType: domains[0].domain_type
        };
        this.setState({
          chosenDomain: chosenDomain
        });
      }
    }
  }, {
    key: "handleDomainChange",
    value: function handleDomainChange(e, _ref) {
      var value = _ref.value;
      this.setState({
        enteredDomain: cleanDomainName(value)
      });
    }
  }, {
    key: "handleEmailChange",
    value: function handleEmailChange(e, _ref2) {
      var value = _ref2.value;
      this.setState({
        email: value
      });
    }
  }, {
    key: "onDomainSelected",
    value: function onDomainSelected(newDomain) {
      this.setState({
        chosenDomain: newDomain
      });
      this.logEvent('Domain Selected');
    }
  }, {
    key: "onCustomDomainSelected",
    value: function onCustomDomainSelected(newCustomDomain) {
      if (newCustomDomain === null) {
        this.setState({
          customDomain: '',
          chosenDomain: {}
        });
        return;
      }
      if (newCustomDomain.length > 3) {
        this.setState({
          customDomain: newCustomDomain,
          chosenDomain: {},
          customDomainInputError: false
        });
      } else {
        this.setState({
          customDomainInputError: true
        });
      }
      this.logEvent('Existing Domain Selected');
    }
  }, {
    key: "onHasCustomDomainChanged",
    value: function onHasCustomDomainChanged() {
      this.setState(function (_ref3) {
        var hasCustomDomain = _ref3.hasCustomDomain;
        return {
          hasCustomDomain: !hasCustomDomain
        };
      });
    }
  }, {
    key: "onPeriodSelected",
    value: function onPeriodSelected(isAnnual) {
      this.setState(function () {
        return {
          isAnnual: isAnnual
        };
      });
      this.logEvent('Plan Period Selected');
    }
  }, {
    key: "logEvent",
    value: function logEvent(step) {
      var business = this.props.business;
      GoogleAnalytics.event('Checkout', "Step ".concat(step), {
        label: business.name
      });
    }
  }, {
    key: "renderHasExistingDomain",
    value: function renderHasExistingDomain() {
      var _this2 = this;
      var _this$state2 = this.state,
        enteredDomain = _this$state2.enteredDomain,
        customDomainInputError = _this$state2.customDomainInputError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        id: "domain-back-button",
        className: "back-button",
        style: {
          cursor: 'inherit'
        }
      }, /*#__PURE__*/React.createElement(Icon, null), "Step 1/4"), /*#__PURE__*/React.createElement(Modal.Header, {
        className: "modal-header centered-content"
      }, "Enter your custom domain"), /*#__PURE__*/React.createElement("p", {
        className: "modal-subheader centered-content body-text blue-color"
      }, "Connect your custom domain to your new site"), /*#__PURE__*/React.createElement(Modal.Content, {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
        className: "domain-search-input domain-search-input-full-width custom-domain-input",
        type: "text",
        placeholder: "mydomain.com",
        action: true,
        labelPosition: "left",
        value: enteredDomain,
        onChange: this.handleDomainChange
      }, /*#__PURE__*/React.createElement(Label, {
        className: "https-label domain-search-input-consistent-padding"
      }, "https://"), /*#__PURE__*/React.createElement("input", {
        className: "borderless-input domain-search-input-consistent-padding"
      }), /*#__PURE__*/React.createElement(Button, {
        id: "domain-connect-button",
        className: "domain-search-button centered-button",
        type: "submit",
        onClick: function onClick() {
          return _this2.onCustomDomainSelected(enteredDomain);
        }
      }, "Connect")), customDomainInputError && /*#__PURE__*/React.createElement("p", {
        className: "error-message"
      }, "Please enter a valid domain."), /*#__PURE__*/React.createElement("p", {
        className: "modal-subheader body-text blue-color"
      }, "Please allow 2-3 business days to process and connect your custom domain to your new published site"), /*#__PURE__*/React.createElement(Button, {
        id: "custom-domain-connect-button",
        className: "publish-now-from-request-button extra-margin centered-content blue-color",
        onClick: this.onHasCustomDomainChanged
      }, "I want to search for a new domain."))));
    }
  }, {
    key: "renderDomainSearch",
    value: function renderDomainSearch() {
      var defaultDomain = this.props.defaultDomain;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        id: "domain-back-button",
        className: "back-button",
        style: {
          cursor: 'inherit'
        }
      }, /*#__PURE__*/React.createElement(Icon, null), "Step 1/4"), /*#__PURE__*/React.createElement(Modal.Header, {
        className: "modal-header centered-content"
      }, "Search for a custom domain for your site"), /*#__PURE__*/React.createElement("p", {
        className: "modal-subheader centered-content body-text blue-color"
      }, "Your domain will be your website\u2019s URL address"), /*#__PURE__*/React.createElement(Modal.Content, {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement(DomainSearchForm, {
        defaultDomain: defaultDomain,
        onDomainSelected: this.onDomainSelected,
        onHasCustomDomainChanged: this.onHasCustomDomainChanged
      })));
    }
  }, {
    key: "renderPaymentOptions",
    value: function renderPaymentOptions() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        id: "checkout-back-button",
        className: "back-button",
        onClick: this.handlePaymentOptionsBackButton
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "caret left"
      }), "Step 2/4"), /*#__PURE__*/React.createElement(Modal.Header, {
        className: "modal-header"
      }, "Let's finalize your site!"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(PaymentOptions, null)));
    }
  }, {
    key: "renderPeriodSelection",
    value: function renderPeriodSelection(onSelectSubscription) {
      var business = this.props.business;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        id: "checkout-back-button",
        className: "back-button",
        onClick: function onClick() {
          return onSelectSubscription({});
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "caret left"
      }), "Step 3/4"), /*#__PURE__*/React.createElement(PeriodSelect, {
        business: business,
        onPeriodSelected: this.onPeriodSelected
      }));
    }
  }, {
    key: "renderCheckoutForm",
    value: function renderCheckoutForm(onSelectPeriod) {
      var _this$state3 = this.state,
        isAnnual = _this$state3.isAnnual,
        chosenDomain = _this$state3.chosenDomain,
        customDomain = _this$state3.customDomain,
        email = _this$state3.email;
      var _this$props = this.props,
        business = _this$props.business,
        onCheckoutCompleted = _this$props.onCheckoutCompleted;
      return /*#__PURE__*/React.createElement(SubscriptionsContextConsumer, null, function (_ref4) {
        var brandIdentity = _ref4.brandIdentity;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
          id: "checkout-back-button",
          className: "back-button",
          onClick: function onClick() {
            return onSelectPeriod('');
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "caret left"
        }), "Step 4/4"), /*#__PURE__*/React.createElement(StripeProvider, {
          apiKey: getStripeApiKey(brandIdentity)
        }, /*#__PURE__*/React.createElement(Elements, null, /*#__PURE__*/React.createElement(CheckoutForm, {
          email: email,
          business: business,
          isAnnual: isAnnual,
          onCheckoutCompleted: onCheckoutCompleted,
          chosenDomain: chosenDomain,
          customDomain: customDomain
        }))));
      });
    }
  }, {
    key: "renderCompletion",
    value: function renderCompletion() {
      this.logEvent('Publish Completion');
      var handlePublishClose = this.props.handlePublishClose;
      function onEventScheduled() {
        setTimeout(function () {
          handlePublishClose();
        }, 10000);
      }
      return /*#__PURE__*/React.createElement(SubscriptionsContextConsumer, null, function (_ref5) {
        var brandIdentity = _ref5.brandIdentity;
        var onboardingLink = getCalendlyOnboardingLink(brandIdentity);
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Completion, {
          title: "Sign Up Complete",
          description: "A Welcome Email will be sent to you shortly with details on how you can contact our support team or get logged into your dashboard"
        }), /*#__PURE__*/React.createElement(Calendly, {
          link: onboardingLink,
          mode: POPUP_CALENDAR,
          onEventScheduled: onEventScheduled,
          popupTrigger: /*#__PURE__*/React.createElement(Button, {
            className: "payment-publish-button centered-button extra-margin",
            content: "Schedule Onboarding"
          })
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state4 = this.state,
        hasCustomDomain = _this$state4.hasCustomDomain,
        chosenDomain = _this$state4.chosenDomain,
        customDomain = _this$state4.customDomain;
      var _this$props2 = this.props,
        showPublishModal = _this$props2.showPublishModal,
        handlePublishOpen = _this$props2.handlePublishOpen,
        handlePublishClose = _this$props2.handlePublishClose,
        checkedOut = _this$props2.checkedOut,
        domains = _this$props2.domains;
      return /*#__PURE__*/React.createElement(SubscriptionsContextConsumer, null, function (_ref6) {
        var selectedSubscription = _ref6.selectedSubscription,
          selectedPeriod = _ref6.selectedPeriod,
          onSelectSubscription = _ref6.onSelectSubscription,
          onSelectPeriod = _ref6.onSelectPeriod;
        var modalBody;
        var hasDomain = domains && domains.length;
        var needsDomainSelection = customDomain.length === 0 && Object.keys(chosenDomain).length === 0;
        var needsPlanSelection = chosenDomain !== null && Object.keys(selectedSubscription).length === 0;
        var needsPeriodSelection = selectedPeriod.length === 0;
        var needsPayment = !needsDomainSelection && !needsPlanSelection && !needsPeriodSelection;
        if (!checkedOut && !hasDomain && needsDomainSelection) {
          modalBody = hasCustomDomain ? _this3.renderHasExistingDomain() : _this3.renderDomainSearch();
        } else if (!checkedOut && needsPlanSelection) {
          modalBody = _this3.renderPaymentOptions();
        } else if (!checkedOut && needsPeriodSelection) {
          modalBody = _this3.renderPeriodSelection(onSelectSubscription);
        } else if (!checkedOut && needsPayment) {
          modalBody = _this3.renderCheckoutForm(onSelectPeriod);
        } else if (checkedOut) {
          modalBody = _this3.renderCompletion(selectedSubscription);
        }
        return /*#__PURE__*/React.createElement(Modal, {
          trigger: /*#__PURE__*/React.createElement(Button, {
            id: "publish-now-button",
            className: "payment-publish-button",
            onClick: handlePublishOpen
          }, "Sign Up"),
          className: "modal-container payment-banner-modal",
          open: showPublishModal,
          dimmer: "inverted",
          onOpen: handlePublishOpen,
          onClose: handlePublishClose
        }, /*#__PURE__*/React.createElement(Button, {
          id: "inside-close-icon",
          className: "inside-close-icon",
          onClick: handlePublishClose,
          icon: true
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "close"
        })), modalBody);
      });
    }
  }]);
  return PublishModal;
}(React.Component);
export { PublishModal as default };
PublishModal.defaultProps = {
  showPublishModal: false,
  checkedOut: false,
  onCheckoutCompleted: function onCheckoutCompleted() {}
};